<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh">Contents</p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc"><a href="#/xhtml/ded#ded">Dedication</a></p>
<p class="toc"><a href="#/xhtml/notes#notes">Notes of Gratitude</a></p>
<p class="toc"><a href="#/xhtml/epigraph#epi">Epigraph</a></p>
<p class="toc"><a href="#/xhtml/authornote#anote">Author’s Note</a></p>
<p class="toc-bot"><a href="#/xhtml/map#map">Map</a></p>
<p class="toc"><a href="#/xhtml/prologue#pro">Prologue</a></p>
<p class="toc"><a href="#/xhtml/chapter1#ch1">One: Born to Die</a></p>
<p class="toc"><span href="#/xhtml/chapter2#ch2" title="Link target outside of Sample">Two: Mom’s the Word</span></p>
<p class="toc"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">Three: Dressing up Time</span></p>
<p class="toc"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">Four: The Good, the Bad, and the Ugly</span></p>
<p class="toc"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">Five: Sex Lives and Videotape</span></p>
<p class="toc"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">Six: Cruise Control</span></p>
<p class="toc"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">Seven: Fever</span></p>
<p class="toc"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">Eight: The Fame Game</span></p>
<p class="toc"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">Nine: First Blood</span></p>
<p class="toc"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">Ten: Casualty of War</span></p>
<p class="toc"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">Eleven: Right Place, Wrong Time</span></p>
<p class="toc"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">Twelve: Miami Vice</span></p>
<p class="toc"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">Thirteen: King of the Catwalk</span></p>
<p class="toc"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">Fourteen: Men on a Mission</span></p>
<p class="toc"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">Fifteen: Bewitched</span></p>
<p class="toc"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">Sixteen: Countdown</span></p>
<p class="toc"><span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">Seventeen: America’s Most Wanted</span></p>
<p class="toc"><span href="#/xhtml/chapter18#ch18" title="Link target outside of Sample">Eighteen: Fear on the Streets</span></p>
<p class="toc"><span href="#/xhtml/chapter19#ch19" title="Link target outside of Sample">Nineteen: Celebrity Bulletin</span></p>
<p class="toc"><span href="#/xhtml/chapter20#ch20" title="Link target outside of Sample">Twenty: Comedy of Errors</span></p>
<p class="toc"><span href="#/xhtml/chapter21#ch21" title="Link target outside of Sample">Twenty-one: The Drag Artist</span></p>
<p class="toc"><span href="#/xhtml/chapter22#ch22" title="Link target outside of Sample">Twenty-two: Blank Check</span></p>
<p class="toc"><span href="#/xhtml/chapter23#ch23" title="Link target outside of Sample">Twenty-three: Appointment with Destiny</span></p>
<p class="toc"><span href="#/xhtml/chapter24#ch24" title="Link target outside of Sample">Twenty-four: No Turning Back</span></p>
<p class="toc-bot"><span href="#/xhtml/epilogue#epi" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc"><span href="#/xhtml/epigraph1#taph" title="Link target outside of Sample">Epitaph</span></p>
<p class="toc"><span href="#/xhtml/adcard#adc" title="Link target outside of Sample">St. Martin’s Paperbacks titles by Wensley Clarkson</span></p>
<p class="toc"><span href="#/xhtml/abouttheauthor#ata" title="Link target outside of Sample">About the Author</span></p>
<p class="toc"><span href="#/xhtml/copyright#crt" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?a53f061c